import React from 'react';
import { string } from 'prop-types';

import './store-details.scss';

export const StoreDistance = ({ distance }) => {
  return (
    <div className="store-distance">{Number(distance).toFixed(2)} mi</div>
  );
};

StoreDistance.propTypes = {
  distance: string.isRequired
};